import { render, staticRenderFns } from "./CombinacaoProdutoModalPdv.vue?vue&type=template&id=ee640e9a&scoped=true"
import script from "./CombinacaoProdutoModalPdv.vue?vue&type=script&lang=js"
export * from "./CombinacaoProdutoModalPdv.vue?vue&type=script&lang=js"
import style0 from "./CombinacaoProdutoModalPdv.vue?vue&type=style&index=0&id=ee640e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee640e9a",
  null
  
)

export default component.exports